import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { MestradoService } from 'app/pos-graduacao/mestrado/service/mestrado.service';
import { environment } from 'environments/environment';
import { DoutoradoService } from 'app/pos-graduacao/doutorado/service/doutorado.service';
import { EspecializacaoService } from 'app/pos-graduacao/especializacao/service/especializacao.service';
import { PosMedService } from 'app/pos-graduacao/pos-med/service/pos-med.service';

@Component({
  selector: 'curso-pos-detalhe',
  templateUrl: './curso-pos-detalhe.component.html',
  styleUrls: ['./curso-pos-detalhe.component.scss']
})
export class CursoPosDetalheComponent implements OnInit, OnChanges {
   @Input() detalhesCurso: any;
   @Input() cursoIdentificador: string;
   @Input() cursoTipo: string;

   cursoTituloCompacto: string;
   environment = environment;
   cursoCarregando = true;

  constructor(
    private mestradoService: MestradoService,
    private doutoradoService: DoutoradoService,
    private especializacaoService: EspecializacaoService,
    private posMedService: PosMedService,
    private stringUtil: StringUtilsService,
    ) { }

  ngOnInit(): void {
    if (environment.loginContexto !== 'FAMAZ') {
      if(this.cursoTipo === 'mestrado') {
          const idCurso = this.cursoIdentificador;
          this.mestradoService.listCursoMestradoId(idCurso).subscribe(titulo => {
          this.cursoTituloCompacto = this.stringUtil.compactarNome(titulo.cursosposgraduacao[0].nome);
        });
      }
      if(this.cursoTipo === 'doutorado') {
        const idCurso = this.cursoIdentificador;
        this.doutoradoService.listCursoDoutoradoId(idCurso).subscribe(titulo => {
        this.cursoTituloCompacto = this.stringUtil.compactarNome(titulo.cursosposgraduacao[0].nome);
      });
      }
      if(this.cursoTipo === 'especializacao') {
        const idCurso = this.cursoIdentificador;
        this.especializacaoService.listCursoEspecializacaoId(idCurso).subscribe(titulo => {
        this.cursoTituloCompacto = this.stringUtil.compactarNome(titulo.cursosposgraduacao[0].title.rendered);
      });
    }
    }
}

  ngOnChanges(changes: SimpleChanges): void {

    const { detalhesCurso } = changes;
    if(detalhesCurso) {
       this.detalhesCurso = this.detalhesCurso;
    }

       this.cursoCarregando = false;
  }

}
